import { cn } from "@/lib/utils";

export const STATUS_OPTIONS = [
    { value: "not_initiated", label: "Not Initiated" },
    { value: "in_progress", label: "In Progress" },
    { value: "pending_from_client", label: "Pending from Client" },
    { value: "pending_from_department", label: "Pending from Department" },
    { value: "completed", label: "Completed" },
];

export const STATUS_LABEL = Object.fromEntries(
    STATUS_OPTIONS.map((s) => [s.value, s.label]),
);

export const STATUS_STYLES = {
    completed: "bg-emerald-50 text-emerald-700 border-emerald-200",
    in_progress: "bg-amber-50 text-amber-700 border-amber-200",
    not_initiated: "bg-red-50 text-red-700 border-red-200",
    pending_from_client: "bg-blue-50 text-blue-700 border-blue-200",
    pending_from_department: "bg-purple-50 text-purple-700 border-purple-200",
};

export const STATUS_DOT = {
    completed: "bg-emerald-500",
    in_progress: "bg-amber-500",
    not_initiated: "bg-red-500",
    pending_from_client: "bg-blue-500",
    pending_from_department: "bg-purple-500",
};

// ----- My Tasks (admin board) statuses -----
export const MYTASK_STATUS_STYLES = {
    not_initiated: "bg-red-50 text-red-700 border-red-200",
    in_progress: "bg-amber-50 text-amber-700 border-amber-200",
    to_be_merged: "bg-indigo-50 text-indigo-700 border-indigo-200",
    billed_not_received: "bg-blue-50 text-blue-700 border-blue-200",
    completed: "bg-emerald-50 text-emerald-700 border-emerald-200",
};

export const MYTASK_STATUS_DOT = {
    not_initiated: "bg-red-500",
    in_progress: "bg-amber-500",
    to_be_merged: "bg-indigo-500",
    billed_not_received: "bg-blue-500",
    completed: "bg-emerald-500",
};

export const MYTASK_STATUS_OPTIONS_PRO = [
    { value: "not_initiated", label: "Not Initiated" },
    { value: "in_progress", label: "In Progress" },
    { value: "to_be_merged", label: "To be Merged" },
    { value: "billed_not_received", label: "Billed but Not Received" },
    { value: "completed", label: "Completed" },
];

export const MYTASK_STATUS_OPTIONS_PERSONAL = [
    { value: "not_initiated", label: "Not Initiated" },
    { value: "in_progress", label: "In Progress" },
    { value: "completed", label: "Completed" },
];

export const MYTASK_STATUS_LABEL = Object.fromEntries(
    MYTASK_STATUS_OPTIONS_PRO.map((s) => [s.value, s.label]),
);

// Options that apply to a My-Task section/category.
export function myTaskStatusOptions(category) {
    return category === "personal"
        ? MYTASK_STATUS_OPTIONS_PERSONAL
        : MYTASK_STATUS_OPTIONS_PRO;
}

export default function StatusBadge({ status, className }) {
    const label = STATUS_LABEL[status] || status;
    return (
        <span
            data-testid={`status-badge-${status}`}
            className={cn(
                "sdc-pill border",
                STATUS_STYLES[status] || "bg-muted text-muted-foreground border-border",
                className,
            )}
        >
            <span className={cn("h-1.5 w-1.5 rounded-full", STATUS_DOT[status])} />
            {label}
        </span>
    );
}
